<template>
    <div>
        <loading-block v-if="isDataLoading"/>
        <div v-else>
            <section>
                <rich-card class="infos" v-if="isSubscriptionOpen">
                    <template slot="header">
                        <strong>Les inscriptions {{new Date().getFullYear()}} sont ouvertes !</strong>
                    </template>
                    <template slot="content">
                        {{infoText}}
                    </template>
                </rich-card>
                <rich-card class="infos" :action="true" v-if="family.current_payments.length === 0 && !hasNoCourses()">
                    <template slot="header"><strong>Paiement en attente</strong></template>
                    <template slot="content">Vous n'avez pas encore préparé votre paiement.</template>
                    <template slot="action">
                        <uni-cta-link style="margin-top: 16px;" class="uni-cta-link--secondary uni-cta-link--small"
                                      to="/paiements">Préparer mon paiement
                        </uni-cta-link>
                    </template>
                </rich-card>
            </section>
            <section>
                <div class="title">
                    <h1>Danseurs</h1>
                    <rich-add-link :to="{name:'users.new'}" label="Ajouter un danseur"/>
                </div>
                <rich-people-list :disabled="family.is_payment_confirmed"
                                  :users="family.users.filter(el => el.is_dancer === true)"/>
            </section>
            <on-boarding v-if="family.first_connection"
                         :user-name="family.users[family.users.length - 1].firstname"
                         @onBoardinIsFinish="updateFamily"
            />
        </div>
    </div>
</template>

<!--<uni-input rule="secret" v-model="email"></uni-input>-->

<script>
    import {mapGetters} from 'vuex'
    import {page} from 'vue-analytics'
    import UniInput from "../components/a-elements/UniInput";
    import {ValidationProvider} from "vee-validate";
    import UniCtaLink from "../components/a-elements/UniCtaLink";
    import RichPeopleList from "../components/b-patterns/RichPeopleList";
    import RichCard from "../components/a-elements/RichCard";
    import RichAddButton from "../components/a-elements/RichAddButton";
    import RichAddLink from "../components/a-elements/RichAddLink";
    import LoadingBlock from "../components/c-blocks/LoadingBlock";
    import OnBoarding from "../components/c-blocks/OnBoarding";
    import UniButton from "../components/a-elements/UniButton";


    export default {
        name: "Home",
        components: {
            UniButton,
            OnBoarding,
            LoadingBlock,
            RichAddLink,
            RichAddButton,
            RichCard,
            RichPeopleList,
            UniCtaLink,
            UniInput,
            ValidationProvider
        },
        computed: {
            ...mapGetters({
                currentFamily: 'currentFamily',
                isSubscriptionOpen: 'isSubscriptionOpen'
            })
        },
        data() {
            return {

                // Check si les données chargent
                isDataLoading: true,
                email: '',
                test: '',
                family: {},
                infoText: ''
            }
        },
        methods: {
            updateFamily() {
                this.family.first_connection = false
                this.$updateModel('families', {family: {first_connection: false}}, this.family.id)
            },
            hasNoCourses() {
                let total = 0
                this.family.users.forEach(user => {
                    total += user.current_courses.length
                })
                return total === 0
            },
        },
        mounted() {

            // let model = {
            //     user: {
            //         name: "MARINGER",
            //         firstname: 'Rémi',
            //         email: 'remi@studio-uni.fr',
            //         is_dancer: true,
            //         tel: "0102030405",
            //         street: "25 Rue Principale",
            //         postal_code: "68120",
            //         city: "Richwiller",
            //         birth_date: "28/11/1996",
            //         family_id: this.currentFamily.id,
            //         role: 'dancer'
            //     }
            // }

            //   this.$createModel('users', model)

            // this.$getModel('users')
            //     .then(data => {
            //         console.log(data) // renvoie tous les users
            //     })
            //
            // this.$getModel('users', 11)
            //     .then(data => {
            //         console.log(data) // renvoie un seul User qui a l'id 1
            //     })

            this.$getModel('families', this.currentFamily.id)
                .then(data => {
                    this.family = data
                    this.$nextTick(() => {
                        this.isDataLoading = false
                    })
                })
                .catch(error => {

                })
        },
        created() {
            if (this.currentFamily.is_admin) {
                this.$router.push('/admin')
            }

            if(this.isSubscriptionOpen) {
                this.$http.get('/options/1')
                    .then((response) => {
                        this.infoText = response.data.inscription_message
                    })
                    .catch(err => {
                        if (this.$isSignatureExpired(err.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
    }

    .infos {
        background: var(--color-primary);
        color: white;
        margin-bottom: 24px;

        strong {
            color: white;
        }
    }

    @include screen-m {
        .title {
            margin-bottom: 16px;
        }
    }
</style>
